export class HrPerExperienceKey {
    private static readonly keyPrefix = 'hrPerExperience';
    public static title = `${HrPerExperienceKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerExperienceKey.keyPrefix}.pageHeader`;
    public static companyName = `${HrPerExperienceKey.keyPrefix}.companyName`;
    public static businessSegment = `${HrPerExperienceKey.keyPrefix}.businessSegment`;
    public static position = `${HrPerExperienceKey.keyPrefix}.position`;

}
